export enum UsageRange {
    TwentyFourHours = '24h',
    ThirtyDays = '30d',
    NinetyDays = '90d',
}